import {
  TimeAttendanceMarkStatus,
  TimeAttendanceMarkType,
} from '@/generated/graphql/types';

import type { TKeys } from './i18n';

// Maps mark types to i18n keys for display labels ("Ingreso", "Salida", etc.).
// Typed as TKeys so t(MARK_TYPE_LABELS[markType]) passes type checking.
export const MARK_TYPE_LABELS: Record<TimeAttendanceMarkType, TKeys> = {
  [TimeAttendanceMarkType.Entry]: 'mark_event_entry',
  [TimeAttendanceMarkType.BreakStart]: 'mark_event_break_start',
  [TimeAttendanceMarkType.BreakEnd]: 'mark_event_break_end',
  [TimeAttendanceMarkType.Exit]: 'mark_event_exit',
};

// Maps backend mark status to compass.ui Tag variant for StatusTag color coding.
export const STATUS_TAG_VARIANT: Record<TimeAttendanceMarkStatus, string> = {
  [TimeAttendanceMarkStatus.OnTime]: 'success',
  [TimeAttendanceMarkStatus.Acceptable]: 'warning',
  [TimeAttendanceMarkStatus.Late]: 'alert',
  [TimeAttendanceMarkStatus.Early]: 'progress', // custom variant
  [TimeAttendanceMarkStatus.OutOfSchedule]: 'info',
  [TimeAttendanceMarkStatus.Registered]: 'pending',
  [TimeAttendanceMarkStatus.Pending]: 'pending',
  [TimeAttendanceMarkStatus.NoRecord]: 'pending',
  [TimeAttendanceMarkStatus.SystemExit]: 'pending',
};

// ACCEPTABLE uses a custom lighter green — compass.ui Tag "success" variant is too saturated
// for the "within tolerance" semantic per Figma spec.
export const STATUS_TAG_CUSTOM_CLASS: Partial<
  Record<TimeAttendanceMarkStatus, string>
> = {
  [TimeAttendanceMarkStatus.Early]: 'tw-cds-bg-progress tw-cds-text-progress',
};
